import '../lib/i18n'
import { createRoot } from 'react-dom/client'
import { createInertiaApp } from '@inertiajs/react'
import AppAppearance from '../components/AppAppearance'
import '@mantine/core/styles.css'
import '../styles/geist.css'
import '../styles/app.css'
import '../styles/v2.css'
const pages = import.meta.glob('../pages/**/*.jsx', { eager: true })
createInertiaApp({
  resolve: name => pages[`../pages/${name}.jsx`],
  setup({ el, App, props }) {
    createRoot(el).render(<AppAppearance><App {...props} /></AppAppearance>)
  },
})
